import { useTranslation } from 'react-i18next';

import { InputType as JoyInputType } from 'core/enums';
import { IRequestForm, IRequestType } from 'support/types';
import { getRequestTypeChoices } from 'support/utils';

import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { getRequiredLabel } from 'coreOld/utils';

import { addRequestSchema } from './addRequestSchema';
import { FieldGroup } from './addRequestStyle';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: IRequestForm) => void;
  onRequiredDateChange: (date: string) => void;
  requestTypes?: IRequestType[];
}

const MIN_WIDTH = 550;

const AddRequestFormView = ({
  isOpen,
  onClose,
  onSubmit,
  onRequiredDateChange,
  requestTypes,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<IRequestForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('buttonLabelAddRequest')}
      submitBtnLabel={t('buttonLabelNext')}
      defaultValues={{ customerNumberNotRequired: false }}
      onSubmit={onSubmit}
      schema={addRequestSchema()}
      minWidth={MIN_WIDTH}
    >
      <Field
        name="projectName"
        label={getRequiredLabel(t('labelProjectOrEndUserName'))}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
          autoFocus: true,
        }}
      />

      <Field
        name="customerCompanyName"
        label={getRequiredLabel(t('labelCustomerCompanyName'))}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
        }}
      />

      <FieldGroup name="requestedDateGroup" wrapperStyle={{ paddingLeft: 0 }}>
        <Field
          name="requiredByDate"
          label={getRequiredLabel(t('labelRequestedDate'))}
          type={InputType.DATE_INPUT}
          inputProps={{
            size: Size.MD,
            minDate: new Date(),
            onChange: onRequiredDateChange,
            fullWidth: false,
          }}
          wrapperStyle={{ width: 'calc(50% - 5px)' }}
        />
      </FieldGroup>

      <FieldGroup name="customerNumberGroup" wrapperStyle={{ paddingLeft: 0 }}>
        <Field
          name="customerNumber"
          label={t('labelCustomerNumber')}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
          }}
        />

        <Field
          name="customerNumberNotRequired"
          type={InputType.CHECKBOX}
          inputProps={{
            label: t('buttonLabelSupportRequestProspect'),
            style: {
              paddingTop: 40,
            },
          }}
        />
      </FieldGroup>

      <FieldGroup name="contactNameGroup" wrapperStyle={{ paddingLeft: 0 }}>
        <Field
          name="customerFirstName"
          label={getRequiredLabel(t('labelCustomerFirstName'))}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
          }}
        />

        <Field
          name="customerLastName"
          label={getRequiredLabel(t('labelCustomerLastName'))}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
          }}
        />
      </FieldGroup>

      <Field
        name="customerEmail"
        label={getRequiredLabel(t('labelCustomerEmail'))}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
        }}
      />

      <Field
        name="type"
        type={JoyInputType.RADIO_GROUP}
        label={getRequiredLabel(t('labelSupportRequestType'))}
        inputProps={{
          defaultValue: -1,
          choices: getRequestTypeChoices(requestTypes),
          required: true,
        }}
      />
    </Form>
  );
};

export default AddRequestFormView;
